import * as marietta from '../../..';
import { SVGSprite } from '../../flash/display';

class ButtonDelete {
    viewObj: SVGElement;

    x: number;

    y: number;

    rotation: number = 0;

    transformMatrix: string;

    targetItem: marietta.webcad.item.MonicaObject;

    public spt: SVGSprite;

    /**
     * コンストラクタ
     * */
    constructor(container: Element, target: marietta.webcad.item.MonicaObject) {
      this.viewObj = <SVGElement>document.getElementById('lib_icon_delete').querySelector('svg > g').cloneNode(true);
      this.viewObj.setAttribute('id', 'icon_delete');
      container.appendChild(this.viewObj);

      // アクション
      if (marietta.webcad.WebCADGlobal.userAgentManager.isMobile || marietta.webcad.WebCADGlobal.userAgentManager.isTablet) {
        this.viewObj.addEventListener('touchstart', this.onMouseDownMe, { passive: false });
      } else {
        this.viewObj.addEventListener('mousedown', this.onMouseDownMe);
      }
      this.targetItem = target;
    }

    /**
 * マウスダウンされた
 * @param MouseEvent
 */
    onMouseDownMe = (e: MouseEvent) => {
      // 選択モードのときは、バブリングさせない
      e.stopPropagation();

      this.targetItem.deleteMe();
    }

    /**
     * 移動 XY
     */
    move(x: number, y: number) {
      this.x = x;
      this.y = y;
      this.updateTranslate();
    }

    /**
    * 移動X
    */
    moveX(x: number) {
      this.x = x;
      this.updateTranslate();
    }

    /**
    * 移動Y
    */
    moveY(y: number) {
      this.y = y;
      this.updateTranslate();
    }

    /**
     * Translateのアップデート
     */
    updateTranslate() {
      // レイヤーのスケールの分、割ってやる事で見た目のサイズを維持する
      const root: SVGSprite = marietta.webcad.WebCADGlobal.layerGroup.spt;
      const sc: number = 1.5 / root.scaleX;

      // x,yについては、位置補正で使用している固定値6.5/25に対してのみスケールを適用する
      this.transformMatrix = `matrix(${sc},0,0,${sc},${
        this.x},${
        this.y})`;

      // this.transformMatrix = "matrix(1,0,0,1," + this.x + "," + this.y + ")";
      this.viewObj.setAttribute('transform', this.transformMatrix);
    }

    /**
     * アイコンの非表示
     */
    hide() {
      this.viewObj.style.display = 'none';
    }

    /**
     * アイコンの表示
     */
    show() {
      this.viewObj.style.display = 'block';
    }
}
export default ButtonDelete;
